import React from 'react';

/**
 * What the LEF report's revealed CLI columns need beyond the report itself (Epic 3, Stories 3.3–3.5):
 * the user's permissions and the period the source chips are loaded for. Resolved once by
 * TPTaxLefReportView and read by TPMultiCLIReportTableGrid, through context rather than a prop chain,
 * like TPTaxReportContext's currency. These are derived values, not state, so there is no reducer.
 *
 * The grid is shared with the CWB report, which provides no value: the default keeps the Calc Builder
 * links disabled and loads no source chips there.
 */
export interface LefCliProvenanceContextValue {
    /** Story 3.5: whether the user's role may view Calculation Builder. */
    canOpenCalcBuilder: boolean;
    /** Stories 3.3 + 3.4: the calculation-execution period ("MAY-2026"); source chips load only when set. */
    sourceExecutionPeriod: string | null;
    /** Story 3.4: whether the user's role may open a chip's target module. */
    canOpenSourceModule?: (module: string) => boolean;
}

export const DEFAULT_LEF_CLI_PROVENANCE: LefCliProvenanceContextValue = Object.freeze({
    canOpenCalcBuilder: false,
    sourceExecutionPeriod: null,
});

export const LefCliProvenanceContext = React.createContext<LefCliProvenanceContextValue>(DEFAULT_LEF_CLI_PROVENANCE);
